import { useI18n } from "../../lib/i18n.jsx";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "../ui/accordion";
import { CONTACT } from "../../lib/content.js";
import { Mail, Phone } from "lucide-react";
import Reveal from "../Reveal.jsx";

export default function FAQ() {
  const { t } = useI18n();
  return (
    <section
      id="faq"
      data-testid="faq-section"
      className="bg-cream py-20 md:py-28"
    >
      <div className="max-w-[1100px] mx-auto px-5 md:px-8">
        <Reveal as="div" className="text-center mb-10">
          <p className="font-handwritten text-summer text-2xl md:text-3xl mb-2">
            {t.faq.kicker}
          </p>
          <h2
            className="font-display font-bold text-winter leading-tight"
            style={{ fontSize: "clamp(2rem, 4.5vw, 3.5rem)" }}
          >
            {t.faq.title}
          </h2>
        </Reveal>

        <Accordion type="single" collapsible className="w-full space-y-3">
          {t.faq.items.map((item, i) => (
            <Reveal key={i} variant="fade" delay={Math.min(i * 30, 240)}>
              <AccordionItem
                value={`item-${i}`}
                className="card-soft border-0 overflow-hidden px-6"
                data-testid={`faq-item-${i}`}
              >
                <AccordionTrigger className="font-display font-bold text-winter text-base md:text-lg py-5 hover:text-summer hover:no-underline text-left">
                  {item.q}
                </AccordionTrigger>
                <AccordionContent className="text-winter/70 leading-relaxed pb-5">
                  {item.a}
                </AccordionContent>
              </AccordionItem>
            </Reveal>
          ))}
        </Accordion>

        {/* Help line */}
        <div className="mt-10 card-soft p-7 md:p-8 text-center">
          <p className="text-winter/65 mb-3">{t.faq.cta_text}</p>
          <div className="flex flex-col sm:flex-row gap-3 justify-center">
            <a href={`mailto:${CONTACT.email}`} className="btn-pill btn-pill-outline">
              <Mail className="w-4 h-4" /> {CONTACT.email}
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
